import { MutationTree } from "vuex";
import {
    ReportCancelTokenMessage,
	ReportState
} from "./types";
import { getDefaultState } from "./state";
import { CancelTokenSource } from "axios";

export const mutations: MutationTree<ReportState> = {
	setAvailableReports(state, reports: any[]) {
		state.AvailableReports = reports;
	},

	setReport(state, report: any) {
		state.Report = report;
	},

	setRelativeHoursToReport(state, hours: number) {
		state.RelativeHoursToReport = hours;
		state.isDateRangeRelative = true;
	},

	setCurrentReportUrl(state, url: string) {
		state.CurrentReportUrl = url;
	},

	setResultCountNumber(state, count: number) {
		state.ResultCount = count;
	},

	setReportLoadingStatus(state, status: boolean) {
		state.ReportLoadingStatus = status;
	},

	setReportErrorStatus(state, status: boolean) {
		state.ReportErrorStatus = status;
	},

	setReportReferenceIDErrorStatus(state, status: boolean) {
		state.ReportReferenceIDErrorStatus = status;
	},

	setReportApiEndpoint(state, endpoint: string) {
		state.ReportApiEndpoint = endpoint;
	},

	setReportTypes(state, types: []) {
		state.ReportTypes = types;
	},

	setIsDateRangeRelative(state, isRelative: boolean) {
		state.isDateRangeRelative = isRelative;
	},

    /**
     * @summary Sets the cancel token source.
     * @param {ReportState} state - The current state of the report module.
     * @param {CancelTokenSource | null} cancelTokenSource - The new cancel token source to set.
     */
    setCancelTokenSource(state: ReportState, cancelTokenSource: CancelTokenSource | null): void {
        state.cancelTokenSource?.cancel(ReportCancelTokenMessage);
        state.cancelTokenSource = cancelTokenSource;
    },

	resetState(state) {
		Object.assign(state, getDefaultState());
	}
};
